import {createContext} from "react-activation";


export interface RouteContextProps {
    path: string
    routes: Routes
    resources: string[]
}

export const RouteContext = createContext<RouteContextProps | undefined>(undefined)